import { MaskType, VaccinationManufacturer, VaccinationType, } from '@clh/api-client';
export const VACCINATION_TYPE_DISPLAY_NAMES = {
    [VaccinationType.Covid19]: 'Covid-19',
    [VaccinationType.Influenza]: 'Annual Influenza (Flu)',
    [VaccinationType.MeaslesMumpsRubella]: 'MMR (Measles, Mumps, Rubella)',
    [VaccinationType.Varicella]: 'Varicella (Chickenpox)',
    [VaccinationType.Hepatitis]: 'Hepatitis B',
    [VaccinationType.Tdap]: 'Tdap',
};
export const VACCINATION_MANUFACTURER_DISPLAY_NAMES = {
    [VaccinationManufacturer.JohnsonAndJohnson]: 'Johnson & Johnson',
    [VaccinationManufacturer.Moderna]: 'Moderna',
    [VaccinationManufacturer.Novavax]: 'Novavax',
    [VaccinationManufacturer.PfizerBiotech]: 'Pfizer-BioNTech',
    [VaccinationManufacturer.Other]: 'Other',
};
export const MASK_TYPE_DISPLAY_NAMES = {
    [MaskType.ThreeM1870Plus]: '3M 1870+',
    [MaskType.ThreeM1860]: '3M 1860',
    [MaskType.ThreeM1860S]: '3M 1860-S',
    [MaskType.Other]: 'Other',
};
